module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_16_9_w_1338.3da03f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_1338.jpg
// module id = 0DvG
// module chunks = 0